"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
const wp_query_params = {
  per_page: 3,
  order: "desc",
  orderby: "date"
};
const wp_query = new WP_Query(wp_query_params);
function FeaturedPropertiesConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="146952" className="grid grid-cols-1 md:grid-cols-3 gap-y-2 md:gap-y-0 divide-y md:divide-y-0 md:divide-x divide-[#14968b]/20">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="p-6 h-[400px] animate-pulse bg-[#112234]/50" />)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="p-8 text-center text-white/70 text-sm border-t border-[#14968b]/20 bg-[#112234]">
        No active engagements available at the moment.
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-y-2 md:gap-y-0 divide-y md:divide-y-0 md:divide-x divide-[#14968b]/20">
      {products.slice(0, 3).map((product, i) => <article key={product.id} data-index={i} className="group flex flex-col bg-[#112234] border-t-2 border-[#14968b] hover:bg-[#112234]/90 transition-colors duration-500">
          <Link to={product.link} className="block relative aspect-[4/3] overflow-hidden bg-[#0d1a29] border-b border-[#14968b]/20">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 grayscale group-hover:grayscale-0" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center text-white/40 bg-[#0d1a29]">
                No Image
              </div>}
            <div className="absolute top-4 left-4">
              <Badge className="bg-[#14968b] text-white rounded-none uppercase tracking-widest text-[10px] border-none px-2 py-0.5 font-sans">
                Project Milestone
              </Badge>
            </div>
          </Link>
          <div className="p-4 lg:p-5 flex flex-col flex-grow">
            <h4 className="text-lg font-bold tracking-tight mb-3 text-white font-sans">
              {product.title}
            </h4>
            {product.short_description && <div className="text-sm text-white/70 line-clamp-2 mb-8 font-sans leading-relaxed" dangerouslySetInnerHTML={{
          __html: product.short_description
        }} />}
            <div className="mt-auto pt-4 border-t border-[#14968b]/20">
              <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="bg-[#14968b] hover:bg-[#14968b]/90 text-white rounded-none w-full uppercase tracking-widest text-xs h-12 transition-all font-sans font-semibold border-none" text="View Engagement Details" showQuantity={false} />
            </div>
          </div>
        </article>)}
    </div>;
}
export default function FirmOverview() {
  const expertiseAreas = ["Project & Programme Management", "ServiceNow Implementation", "Milestone-Based Delivery", "Professional PMP Training", "Field & Network Services"];
  return;
}